// extracted by mini-css-extract-plugin
module.exports = {"lozengeBtn":"_1IXoThvc","lozenge":"_1uxo10-A"};